import { createFileRoute } from '@tanstack/react-router';
import { EditStandingOrderPage } from '../components/pages/StandingOrdersPage/EditStandingOrderPage';

export const Route = createFileRoute('/account/standing-orders_/$orderId_/$step')({
  component: EditStandingOrderPage,
});
